<template>
  <section>
    <sweet-modal ref="modal"
                 overlay-theme="dark"
                 blocking
                 :enable-mobile-fullscreen="false">
      <div v-html="$t('message.line_contact.detail')"></div>
      <div class="mt-4">
        <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
          <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
        </a>
      </div>
    </sweet-modal>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      SweetModal
    },
    data () {
      return {}
    },
    computed: {
      ...mapState('user', ['userVerification'])
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/LineContactModal.vue